import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {PaqueteSegurosSeguros} from '../_models/paquete-seguros-seguros';
import {PlagaProductoAgricola} from '../_models/plaga-producto-agricola';
@Injectable({
  providedIn: 'root'
})
export class PaqueteSegurosSegurosService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/paquetesSegurosSeguros';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PaqueteSegurosSeguros[] ) );
  }

  listadoPorPaquete( id: string ) {
    return this.httClient.get( this.rutServicio + '/paqueteSeguro/' + id ).pipe( map( res => res as PaqueteSegurosSeguros[] ) );
  }

  listadoValidarSegurosPaquetes( idPaqueteSeguro: string, idProducto: string, idSolicitudUnidadCredito: string ) {
    return this.httClient.get( this.rutServicio + `/validarSegurosPaquete/paqueteSeguro/${idPaqueteSeguro}/producto/${idProducto}/solicitudUnidadCredito/${idSolicitudUnidadCredito}` ).pipe( map( res => res as PaqueteSegurosSeguros[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PaqueteSegurosSeguros[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PaqueteSegurosSeguros ) );
  }

  crear( regCrear: PaqueteSegurosSeguros ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PaqueteSegurosSeguros ) );
  }

  actualizar( regActualizar: PaqueteSegurosSeguros ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
